import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
export default function InstallBanner() {
  const [hidden, setHidden] = useState(
      localStorage.getItem("install-dismissed") === "true",
    ),
    [prompt, setPrompt] = useState(null),
    [help, setHelp] = useState(false);
  useEffect(() => {
    const ready = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    const installed = () => setHidden(true);
    addEventListener("beforeinstallprompt", ready);
    addEventListener("appinstalled", installed);
    return () => {
      removeEventListener("beforeinstallprompt", ready);
      removeEventListener("appinstalled", installed);
    };
  }, []);
  if (hidden || matchMedia("(display-mode: standalone)").matches) return null;
  const install = async () => {
    if (!prompt) {
      setHelp(true);
      return;
    }
    await prompt.prompt();
    const choice = await prompt.userChoice;
    if (choice.outcome === "accepted") setHidden(true);
    setPrompt(null);
  };
  return (
    <aside className="install-banner">
      <button
        className="icon"
        aria-label="Fechar convite de instalação"
        onClick={() => {
          setHidden(true);
          localStorage.setItem("install-dismissed", "true");
        }}
      >
        <X size={15} />
      </button>
      <b>Instale o app neste dispositivo</b>
      <p>
        {help
          ? "Use a opção de instalação no menu do navegador."
          : "Acesso rápido ao gerador e às suas análises."}
      </p>
      <button className="install-action" onClick={install}>
        <Download size={16} />
        Instalar aplicativo
      </button>
    </aside>
  );
}
